import Cookies from 'js-cookie';
import store from '../store/store';
function checkEnv() {
  const ua = window.navigator.userAgent.toLowerCase()
  if (ua.indexOf("chuangqi") > -1 || window.ReactNativeWebView) {
    return '客户端'
  } else {
    return 'h5'
  }
  // if (ua.match(/MicroMessenger/i) == "micromessenger") {
  //   return '微信'
  // } else {
  //   return '普通网页'
  // }
}

// 判断是哪个 tab
function getPageTypeText(val) {
  switch (val) {
    case 1:
      return '投票排行'
    case 2:
      return '投票说明'
    default:
      return '投票首页'
  }
}

export const tracking = {
  // 页面访问
  onLoad: (options) => {
    // console.log('tracking onLoad', options)
    window.collectEvent('voting_activities_access', options)
  },
  // 点击各种按钮时
  onClickButton: () => {
    const { big_activity_name } = store.state.pageTrackingOptions
    let temp = {}
    temp.big_activity_name = big_activity_name
    temp.big_activity_source_channel = checkEnv()
    window.collectEvent('complete_vote', temp)
  },
  // 获取页面访问埋点信息
  getPageAccessTrackingOptions: (val = 1) => {
    // console.log('getPageAccessTrackingOptions 入参', val)
    const { voteInfo } = store.state
    let options = {
      big_activity_page_type: getPageTypeText(val), // 页面类型
      big_activity_name: voteInfo.title, // 活动名称
      big_activity_id: voteInfo.id, // 活动id
      big_activity_source_channel: checkEnv(), // 来源渠道 样例：客户端、网页版、PC端、小程序（暂无）
      // big_activity_login_status: Cookies.get('jwt') ? '登录' : '未登录'  // 登录状态
    }
    store.commit("setTrackingOptions", options);
    return options;
  },
}